
import { Vue, Component } from 'vue-property-decorator';
import Api from '@/services/api';

@Component
export default class SupportSubject extends Vue {
  public dialog = false;
  public formTitle = 'موضوعات پشتیبانی';
  public desserts = [];
  public businessUnits = [];
  public editedIndex = -1;
  public headers = [
    { text: 'شماره', value: 'id' },
    { text: 'عنوان', value: 'name' },
    { text: 'واحد سازمانی', value: 'businessUnit' },
    { text: 'عملیات', value: 'action', sortable: false }
  ];
  public editedItem = {
    id: 0,
    businessUnitId: 0,
    name: ''
  };
  public defaultItem = {
    id: 0,
    businessUnitId: 0,
    name: ''
  };
  public breadcrumbItems = [
    {
      text: 'صفحه اصلی',
      disabled: false,
      href: '/'
    },
    {
      text: 'موضوعات پشتیبانی',
      disabled: true,
      href: ''
    }
  ];

  async created() {
    await this.initialize();
  }

  async initialize() {
    this.$showLoading();
    await Api.getSupportSubjects().then((response: any) => {
      this.desserts = response.data;
    });
    await Api.getBusinessUnits().then((response: any) => {
      this.businessUnits = response.data;
      this.$hideLoading();
    });
  }

  async close() {
    this.dialog = false;
    this.editedItem = Object.assign({}, this.defaultItem);
    this.editedIndex = -1;
    this.initialize();
  }

  editItem(item: any) {
    this.editedIndex = this.desserts.indexOf(item);
    this.editedItem = Object.assign({}, item);
    this.dialog = true;
  }

  async save() {
    const isValid = (this.$refs.Observer as any).validate();
    if (!isValid) {
      return;
    }

    this.$showLoading();
    if (this.editedIndex > -1) {
      await Api.editSupportSubject(this.editedItem).then((response: any) => {
        this.close();
        this.$showNotification('success', 'Support Subject Updated');
        this.$hideLoading();
      });
    } else {
      await Api.createSupportSubject(this.editedItem).then((response: any) => {
        this.close();
        this.$showNotification('success', 'Support Subject Created');
        this.$hideLoading();
      });
    }
  }

  async deleteItem(id: number) {
    const confirmed = await this.$showConfirm('هشدار', 'آیا مطمئن هستید که می خواهید این مورد را حذف کنید؟');
    if (confirmed) {
      this.$showLoading();
      await Api.deleteSupportSubject(id).then((response: any) => {
        this.close();
        this.$hideLoading();
      });
    }
  }
}
